<template>
  <div class="ph_layout_nav_lay">
    <Head
      v-if="isHeaderMenuVisible"
      :class="headerMenuExpanded ? '' : 'hidden'"
    ></Head>
    <navigation>
      <router-view></router-view>
    </navigation>
    <BackToMoon v-if="isFixedBarVisible"></BackToMoon>
  </div>
</template>

<script>
import Head from './Head.vue'
import BackToMoon from './BackToMoon.vue'
export default {
  name: 'NavLay',
  components: {
    Head,
    BackToMoon
  },
  computed: {
    headerMenuExpanded() {
      return this.$store.state.common.headerMenuExpanded
    },
    isHeaderMenuVisible() {
      return this.$store.state.common.isHeaderMenuVisible
    },
    isFixedBarVisible() {
      return this.$store.state.common.isFixedBarVisible
    }
  }
}
</script>

<style lang="scss" scoped>
.ph_layout_nav_lay {
  min-width: 1200px;
  height: 100%;
  background: #f7f7f7;
  .hidden {
    transform: translateY(-100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/NavLay.vue